module.exports = __webpack_public_path__ + "img/hotels.com-logo.a5031203.svg";